import { ForgotPasswordAdapters } from '../adapters';
import { resetPassword as resetPasswordClient } from '../clients/ResetPassword';
import { sendOtp as sendOtpClient } from '../clients/SendOtp';
import { verifyOtp as verifyOtpClient } from '../clients/VerifyOtp';
import {
  ForgotPasswordApiError,
  ForgotPasswordRateLimitedError,
} from '../errors';
import type {
  IResetPasswordRequest,
  TResetPasswordResponse,
  ISendRecoveryCodeRequest,
  TSendRecoveryCodeResponse,
  IVerifyCodeRequest,
  IVerifyCodeResponse,
} from '../types/ForgotPassword';

const chainTypedErrors = (error: unknown): Error =>
  ForgotPasswordRateLimitedError.fromAxiosError(error) ??
  ForgotPasswordApiError.fromAxiosError(error) ??
  (error instanceof Error ? error : new Error(String(error)));

const sendRecoveryCode = async (
  input: ISendRecoveryCodeRequest,
): Promise<TSendRecoveryCodeResponse> => {
  try {
    await sendOtpClient(ForgotPasswordAdapters.toSendOtpPayload(input));
  } catch (error) {
    throw chainTypedErrors(error);
  }
};

const verifyCode = async (input: IVerifyCodeRequest): Promise<IVerifyCodeResponse> => {
  try {
    const apiResponse = await verifyOtpClient(ForgotPasswordAdapters.toVerifyOtpPayload(input));
    return ForgotPasswordAdapters.toVerifyCodeResponse(apiResponse);
  } catch (error) {
    throw chainTypedErrors(error);
  }
};

const resetPassword = async (
  input: IResetPasswordRequest,
): Promise<TResetPasswordResponse> => {
  try {
    await resetPasswordClient(ForgotPasswordAdapters.toResetPasswordPayload(input));
  } catch (error) {
    throw chainTypedErrors(error);
  }
};

export const ForgotPasswordService = {
  sendRecoveryCode,
  verifyCode,
  resetPassword,
};
